<router-outlet *appRemountOnLanguageChange></router-outlet>

@if (infoLoading.requestingData$ | async; as loadingMsg) {
  <div class="info-loader">
    <mat-spinner diameter="48"></mat-spinner>
    <h3>{{ loadingMsg }}</h3>
  </div>
}
